const baseURL = "/v1/Formacao";

const service = {
  methods: {
    $buscarAtas(params) {
      return this.$api().get(`${baseURL}/AptosParaAta`, params);
    },
    $baixarAta(id, params) {
      return this.$api().get(`${baseURL}/${id}/BaixarAtas`, params)
    },
    $enviarAta(id, body) {
      return this.$api().post(`${baseURL}/${id}/Ata`, body);
    },
    $aprovarAta(id) {
      return this.$api().patch(`${baseURL}/${id}/AprovarAta`);
    },
    $reprovarAta(id) {
      return this.$api().patch(`${baseURL}/${id}/ReprovarAta`);
    },
    $buscarAtasParaAprovacao(params) {
      return this.$api().get(`${baseURL}/AtasParaAprovacao`, params);
    },
    $detalharAta(id) {
      return this.$api().get(`${baseURL}/${id}/Ata`);
    }
  },
};

export default service;
